import type { AuthMeResponse, Permission, PermissionScope } from "@pulsar-anvil-studios/api-types";
import { AUTH_LOGOUT } from "@pulsar-anvil-studios/routes/auth";
import { type ReactNode, useState } from "react";
import { api, apiPath } from "@/api/client";
import { buildPermissionMap, checkPermission } from "@/lib/permissions";
import { AuthContext } from "./AuthContext";

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [identity, setIdentity] = useState<AuthMeResponse | null>(null);
  const [isAuthLoading, setAuthLoading] = useState(false);

  const permissionMap = buildPermissionMap(identity?.permissions ?? []);

  const hasPermission = (permission: Permission, context?: Partial<PermissionScope>) =>
    checkPermission(permissionMap, permission, context);

  const logout = async () => {
    try {
      await api.post(apiPath(AUTH_LOGOUT));
    } catch {
      // fire-and-forget
    }
    setIdentity(null);
    // Full reload intentional — clears all client-side state on session expiry
    window.location.href = "/login";
  };

  return (
    <AuthContext
      value={{
        identity,
        isAuthenticated: identity !== null,
        isAuthLoading,
        setIdentity,
        setAuthLoading,
        hasPermission,
        logout,
      }}
    >
      {children}
    </AuthContext>
  );
};
